import ReactGA from 'react-ga4';

let sharedContext = {};

export function setContext(ctx = {}) {
  sharedContext = { ...sharedContext, ...ctx };
}

export function track(name, params = {}) {
  ReactGA.event(name, { ...sharedContext, ...params });
}
